var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 50,
    height: 50,
    viewBox: "0 0 172 172",
    style: {
      fill: "#000000"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,172v-172h172v172z",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86,6.88c-43.65603,0 -79.12,35.46397 -79.12,79.12c0,43.65603 35.46397,79.12 79.12,79.12c43.65603,0 79.12,-35.46397 79.12,-79.12c0,-43.65603 -35.46397,-79.12 -79.12,-79.12zM86,13.76c39.93779,0 72.24,32.30221 72.24,72.24c0,39.93779 -32.30221,72.24 -72.24,72.24c-39.93779,0 -72.24,-32.30221 -72.24,-72.24c0,-39.93779 32.30221,-72.24 72.24,-72.24zM55.04,41.28c-5.65883,0 -10.32,4.66117 -10.32,10.32c0,5.65883 4.66117,10.32 10.32,10.32c5.65883,0 10.32,-4.66117 10.32,-10.32c0,-5.65883 -4.66117,-10.32 -10.32,-10.32zM55.04,48.16c1.9406,0 3.44,1.4994 3.44,3.44c0,1.9406 -1.4994,3.44 -3.44,3.44c-1.9406,0 -3.44,-1.4994 -3.44,-3.44c0,-1.9406 1.4994,-3.44 3.44,-3.44zM48.16,65.36c-1.89978,0.00019 -3.43981,1.54022 -3.44,3.44v51.6c0.00019,1.89978 1.54022,3.43981 3.44,3.44h13.76c1.89978,-0.00019 3.43981,-1.54022 3.44,-3.44v-51.6c-0.00019,-1.89978 -1.54022,-3.43981 -3.44,-3.44zM75.68,65.36c-1.89978,0.00019 -3.43981,1.54022 -3.44,3.44v51.6c0.00019,1.89978 1.54022,3.43981 3.44,3.44h13.76c1.89978,-0.00019 3.43981,-1.54022 3.44,-3.44v-25.8c0,-4.74563 3.85437,-8.6 8.6,-8.6c4.74563,0 8.6,3.85437 8.6,8.6v8.6v17.2c0.00019,1.89978 1.54022,3.43981 3.44,3.44h13.76c1.89978,-0.00019 3.43981,-1.54022 3.44,-3.44v-29.24c0,-14.20854 -11.59146,-25.8 -25.8,-25.8c-4.42546,0 -8.39448,1.43156 -12.04,3.4064c-0.01861,-1.88665 -1.55326,-3.40631 -3.44,-3.4064zM51.6,72.24h6.88v44.72h-6.88zM79.12,72.24h6.88v2.80844c0.00017,1.37921 0.824,2.62502 2.09306,3.16514c1.26906,0.54012 2.73802,0.27014 3.73209,-0.68592c3.40844,-3.27421 7.99223,-5.28765 13.09485,-5.28765c10.49066,0 18.92,8.42934 18.92,18.92v25.8h-6.88v-13.76v-8.6c0,-8.49837 -6.98163,-15.48 -15.48,-15.48c-8.49837,0 -15.48,6.98163 -15.48,15.48v22.36h-6.88z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinicon);
export default __webpack_public_path__ + "static/media/linkedinicon.1542c6dabf63a50958360317635bb630.svg";
export { ForwardRef as ReactComponent };